import axios from 'axios';

// Creating axios instance with custom configuration
const api = axios.create({
    headers: {
        'Content-Type': 'application/json'
    }
});

api.interceptors.response.use(
    response => response.data,
    error => Promise.reject(error)
);

export default api;
